<ng-template #content>
  <ng-content />
</ng-template>

@switch (appearance()) {
  @case ('primary') {
    <div
      [ngClass]="
        isEnabled()
          ? 'btn bg-[var(--faculty-600,platform-600)] border-border-[var(--faculty-600,platform-600)]'
          : 'bg-gray-500 border-gray-500'
      "
      (click)="isEnabled() && buttonClick.emit($event)"
      class="btn-container text-white border-solid border-[2.5px]"
    >
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }
  @case ('outline') {
    <div
      [ngClass]="
        isEnabled()
          ? 'btn border-[var(--faculty-600,platform-600)] text-[var(--faculty-600,platform-600)]'
          : 'border-[var(--faculty-200,platform-200)] text-[var(--faculty-200,platform-200)]'
      "
      (click)="isEnabled() && buttonClick.emit($event)"
      class="btn-container border-[2.5px] bg-transparent border-solid"
    >
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }
  @case ('danger') {
    <div
      [ngClass]="isEnabled() ? 'btn border-red-700 text-red-700' : 'border-red-200 text-red-200'"
      (click)="isEnabled() && buttonClick.emit($event)"
      class="btn-container border-[2.5px] bg-transparent border-solid"
    >
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }
  @case ('white') {
    <div
      [ngClass]="isEnabled() ? 'btn text-[var(--faculty-600,platform-600)]' : 'text-[var(--faculty-200),platform-200)]'"
      (click)="isEnabled() && buttonClick.emit($event)"
      class="btn-container bg-white"
    >
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }
}
